import * as z from 'zod';

export type TreeifyError<T> = ReturnType<typeof z.treeifyError<T>>;

export function errorsFromSafeResult<T>(result: z.ZodSafeParseResult<T>): TreeifyError<T> {
  if (result.success) {
    return { errors: [] } as unknown as TreeifyError<T>;
  }

  return z.treeifyError(result.error);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export const nonLiteralString = () => z.string().transform((x) => x as string & {});

export const timestampToDate = z.codec(
  z.iso.datetime(), // input schema: ISO date string
  z.date(), // output schema: Date object
  {
    decode: (isoString) => new Date(isoString), // ISO string → Date
    encode: (date) => date.toISOString(), // Date → ISO string
  }
);
